import LeftPanelTabs from './LeftPanelTabs';

export default LeftPanelTabs;